<template>
  <div>
		<ts-loading-banner :loading="loading">
			<div class="row">
				<div class="col-md-12">
					<label class="ts-text-xs required">{{
						$t('customerProfile.customerName')
					}}</label>
					<input
						v-model="model.customer_name"
						type="text"
						class="form-control"
						:class="{ 'is-invalid': errors.has('customer_name') }"
					/>
					<div
						class="invalid-feedback ts-text-xs"
						v-if="errors.has('customer_name')"
					>
						{{ errors.first('customer_name') }}
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="ts-w-full">
						<a-radio-group v-model="model.gender" class="ts-p-3">
							<a-radio value="Male">Male</a-radio>
							<a-radio value="Female">Female</a-radio>
							<a-radio value="Other">Other</a-radio>
						</a-radio-group>
					</div>
					<div class="validate ts-text-xs" v-if="errors.has('gender')">
						{{ errors.first('gender') }}
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<label class="ts-text-xs required">{{
						$t('customerProfile.phoneNumber')
					}}</label>
					<input
						v-model.trim="model.contact_number"
						type="text"
						class="form-control"
						:class="{ 'is-invalid': errors.has('contact_number') }"
					/>
					<div
						class="invalid-feedback ts-text-xs"
						v-if="errors.has('contact_number')"
					>
						{{ errors.first('contact_number') }}
					</div>
				</div>
			</div>
			<div class="row ts-mt-2">
				<div class="col-md-12">
					<label class="ts-text-xs">{{
						$t('customerProfile.idCard')
					}}</label>
					<input
						v-model.trim="model.ss_id_card"
						type="text"
						class="form-control"
						:class="{ 'is-invalid': errors.has('ss_id_card') }"
					/>
					<div
						class="invalid-feedback ts-text-xs"
						v-if="errors.has('ss_id_card')"
					>
						{{ errors.first('ss_id_card') }}
					</div>
				</div>
			</div>
			<div class="row ts-mt-3">
				<div class="col-md-12">
					<h4 class="ts-uppercase ts-text-gray-500">
						{{ $t('customerProfile.address') }}
					</h4>
					<div
						class="ts-border-blue-300 ts-border ts-rounded ts-p-3"
					>
						<div class="row ts-space-y-2">
							<div class="col-md-12">
								<label class="ts-text-xs">{{
									$t('customerProfile.province')
								}}</label>
								<a-select
									v-model="model.province_code"
									:options="provinceList"
									@change="onProvinceChange"
									showSearch
									:filterOption="
										(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
									"
									class="ts-w-full"
								></a-select>
								<div
									class="validate ts-text-xs"
									v-if="errors.has('province_code')"
								>
									{{ errors.first('province_code') }}
								</div>
							</div>
							<div class="col-md-12">
								<label class="ts-text-xs">{{
									$t('customerProfile.district')
								}}</label>
								<a-select
									v-model="model.district_code"
									:options="districts"
									showSearch
									@change="onDistrictChange"
									:filterOption="
										(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
									"
									class="ts-w-full"
								></a-select>
								<div
									class="validate ts-text-xs"
									v-if="errors.has('district_code')"
								>
									{{ errors.first('district_code') }}
								</div>
							</div>
							<div class="col-md-12">
								<label class="ts-text-xs">{{
									$t('customerProfile.commune')
								}}</label>
								<a-select
									v-model="model.commune_code"
									:options="communes"
									showSearch
									@change="onCommuneChange"
									:filterOption="
										(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
									"
									class="ts-w-full"
								></a-select>
								<div
									class="validate ts-text-xs"
									v-if="errors.has('commune_code')"
								>
									{{ errors.first('commune_code') }}
								</div>
							</div>
														<div class="col-md-12">
								<label class="ts-text-xs">{{
									$t('customerProfile.village')
								}}</label>
								<a-select
									v-model="model.village_code"
									:options="villages"
									showSearch
									:filterOption="
										(input, option) =>
											option.componentOptions.children[0].text
												.toLowerCase()
												.indexOf(input.toLowerCase()) >= 0
									"
									class="ts-w-full"
								></a-select>
								<div
									class="validate ts-text-xs"
									v-if="errors.has('village_code')"
								>
									{{ errors.first('village_code') }}
								</div>
							</div>
							<div class="col-md-12">
								<label class="ts-text-xs">{{
									$t('customerProfile.zipCode')
								}}</label>
								<input
									v-model.trim="model.zip_code"
									type="text"
									class="form-control"
									:class="{ 'is-invalid': errors.has('zip_code') }"
								/>
								<div
									class="invalid-feedback ts-text-xs"
									v-if="errors.has('zip_code')"
								>
									{{ errors.first('zip_code') }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ts-loading-banner>
			<div
				:style="{
					position: 'absolute',
					bottom: 0,
					width: '100%',
					borderTop: '1px solid #e8e8e8',
					padding: '10px 16px',
					textAlign: 'right',
					left: 0,
					background: '#fff',
					borderRadius: '0 0 4px 4px',
				}"
			>
				 <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
            {{ $t('cancel') }}
          </ts-button>
          <ts-button
            color="primary"
            @click.prevent="onSave"
            :waiting="waiting"
            >{{ $t('save') }}</ts-button
          >
			</div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'companyForm',
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
      districts: [],
      communes: [],
      villages: [],
      model: {
        customer_id: 0,
        cus_type_id: 2, // for sale lok dom
        customer_name: null,
        gender: null,
        contact_number: null,
        contact_email: null,
        facebook_account: null,
        city_province: null,
        year_of_born: null,
        account_number: null,
        is_general_customer: false,
        is_membership: false,
        is_allow_update_gps_location: false,
        membership_discount_rate: 0,
        company_name: null,
        zip_code: null,
        credit_day: 0,
        credit_amount: 0,
        province_code: null,
        disctrict_code: null,
        commune_code: null,
        village_code: null,
        sale_id: null,
		ss_id_card: null,
		approve_status: 2 // set default to approve
      },
    }
  },
  created() {
    this.fetchResources()
  },
  computed: {
    ...mapState('customer/profile', ['edit_data']),
    listType() {
      return this.$store.state.customer.profile.customerType.map((el) => ({
        value: el.cus_type_id,
        label: el.customer_type,
      }))
    },
    saleList() {
      return this.$store.state.customer.profile.sales.map((el) => ({
        value: el.user_id,
        label: el.name,
      }))
    },
    provinceList() {
      return this.$store.state.customer.profile.provinces.map((el) => ({
        value: el.province_code,
        label: el.name_en,
      }))
    },
  },
  methods: {
    ...mapActions('customer/profile', [
      'getDistrict',
      'getCommune',
      'getVillage',
    ]),
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('customer/profile/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('data', response.data)
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchResources(){
      this.loading = true
      this.$store.dispatch('customer/profile/fetchResources').finally(() => {
        this.loading = false
      })
    },
    async onProvinceChange(value, opt) {
      this.model.disctrict_code = null
      this.model.commune_code = null
      this.model.village_code = null
      this.loading = true
      await this.getDistrict(value)
        .then((response) => {
          this.districts = response.data.map((el) => ({
            value: el.district_code,
            label: el.name_en,
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onDistrictChange(value, opt) {
      this.model.commune_code = null
      this.model.village_code = null
      this.loading = true
      await this.getCommune(value)
        .then((response) => {
          this.communes = response.data.map((el) => ({
            value: el.commune_code,
            label: el.name_en,
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onCommuneChange(value, opt) {
      this.model.village_code = null
      this.loading = true
      await this.getVillage(value)
        .then((response) => {
          this.villages = response.data.map((el) => ({
            value: el.village_code,
            label: el.name_en,
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
